import { FontWeight } from '@billy/design-system'

const typography = {
  body1: {
    fontSize: 14,
    lineHeight: '24px',
    fontWeight: FontWeight.Regular,
  },
  body2: {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: FontWeight.Regular,
  },
  body3: {
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: FontWeight.Light,
  },
  tableHeader: {
    fontSize: 14,
    lineHeight: '24px',
    fontWeight: FontWeight.Medium,
  },
  display: {
    fontSize: 37,
    lineHeight: '51.8px',
    fontWeight: FontWeight.Regular,
  },
  h1: {
    fontSize: 32,
    lineHeight: '36px',
    fontWeight: FontWeight.Regular,
  },
  h2: {
    fontSize: 24,
    lineHeight: '36px',
    fontWeight: FontWeight.Regular,
  },
  h3: {
    fontSize: 20,
    lineHeight: '24px',
    fontWeight: FontWeight.Medium,
  },
  h4: {
    fontSize: 18,
    lineHeight: '24px',
    fontWeight: FontWeight.Medium,
  },
  h5: {
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: FontWeight.Regular,
  },
  h6: {
    fontSize: 13,
    lineHeight: '24px',
    fontWeight: FontWeight.Regular,
  },
  small1: {
    fontSize: 12,
    lineHeight: '24px',
    fontWeight: FontWeight.Regular,
  },
  small2: {
    fontSize: 11,
    lineHeight: '24px',
    fontWeight: FontWeight.Medium,
  },
  toast: {
    fontSize: 14,
    lineHeight: '24px',
    fontWeight: FontWeight.Medium,
  },
}

export default typography
